import { useCallback } from 'react';

import { FieldControllerProps } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceUsingNameAsNameForInvoicing, WithNameForInvoicing } from './nameForInvoicing.types';

type MedicalServiceUsingNameAsNameForInvoicingFieldProps = Omit<
   FieldControllerProps<
      'usingNameAsNameForInvoicing',
      MedicalServiceUsingNameAsNameForInvoicing | null,
      WithNameForInvoicing,
      'trigger'
   >,
   'required'
>;

export const MedicalServiceUsingNameAsNameForInvoicingField = (
   props: MedicalServiceUsingNameAsNameForInvoicingFieldProps
): JSX.Element => {
   const handleSelectionChange = useCallback(() => {
      props.trigger('nameForInvoicing');
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <Checkbox
         testId={props.name}
         label={medicalServiceTranslationKeys.shared.usingNameAsNameForInvoicing.field.label}
         controller={props.register(props.name)}
         defaultValue={props.defaultValue}
         onSelectionChange={handleSelectionChange}
      />
   );
};
